import { useForm } from '@tanstack/react-form'
import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { PageSectionPrimary, Toast } from 'ui/components'

import { handlerServerError } from '@orbit/errors'

import { useHRRContext } from '../../../../context'
import { QuestionnaireDemo } from '../../../../types'
import {
  ACHActivity,
  CashActivity,
  CashWithdrawals,
  CheckDebits,
  ConsumerAccount,
  DebitCard,
  DepositActivity,
  DepositLog,
  InternalTransfers,
  Questions,
  RepetitiveCashTransactions,
  Review,
  SignedCompletion,
  WireActivity
} from './components'

export const Herring = () => {
  const { data } = useHRRContext()
  const { showQuestionnaire1, highRiskReviewId } = data

  const formApi = useForm({
    defaultValues: showQuestionnaire1,
    listeners: {
      onChange: ({ formApi }) => {
        saveQuestionnaire({ questionnaire1: formApi.state.values, id: highRiskReviewId })
      },
      onChangeDebounceMs: 500
    }
  })

  const { mutate: saveQuestionnaire } = useMutation<void, Error, { questionnaire1: QuestionnaireDemo; id: number }>({
    mutationFn: (opts) => Request.put(Request.urls.bank.hrrSave, opts),
    onSuccess: () => {
      Toast.successSmallUpdatable('Report has been saved.')
    },
    onError: (error) => handlerServerError(error)
  })

  return (
    <PageSectionPrimary title="Red Flags to Distinguish Priority SARs" face="solid" anchor="red_flags">
      <CashActivity formApi={formApi} />
      <RepetitiveCashTransactions formApi={formApi} />
      <CashWithdrawals formApi={formApi} />
      <DepositLog formApi={formApi} />
      <InternalTransfers formApi={formApi} />
      <ConsumerAccount formApi={formApi} />
      <DepositActivity formApi={formApi} />
      <CheckDebits formApi={formApi} />
      <WireActivity formApi={formApi} />
      <ACHActivity formApi={formApi} />
      <DebitCard formApi={formApi} />
      <Questions formApi={formApi} />
      <Review formApi={formApi} />
      <SignedCompletion formApi={formApi} />
    </PageSectionPrimary>
  )
}
